import type { UserImageProps } from "@circleco/ui-kit";
import type { NotificationActionType } from "@circle-react/types/Notification";
import { UserImage } from "@circle-react-shared/uikit/UserImage";
import { NotificationTypeIcon } from "./NotificationTypeIcon";

export interface UserImageWithIconProps {
  action: NotificationActionType;
  name: string;
  size?: UserImageProps["size"];
  src?: string;
}

export const UserImageWithIcon = ({
  src = "",
  name,
  action,
  size = "8",
}: UserImageWithIconProps) => (
  <div className="relative mr-3 shrink-0">
    <UserImage src={src} name={name} size={size} />
    <NotificationTypeIcon action={action} />
  </div>
);
